import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'
import { type CreateRegularKekPostRequest, ZHSMRegularKek } from '../types'

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZHSMRegularKek,
  error: z.boolean()
})

export type CreateGroupRegularKekApiResponse = z.infer<typeof ZHSMRegularKek>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createKek (
  CreateRegularKekPostRequest: CreateRegularKekPostRequest,
  onSuccess: (successResponse: CreateGroupRegularKekApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/app-config-service/api/v1/crypto/kek'

  interceptedAxios
    .post(url, CreateRegularKekPostRequest)
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      // istanbul ignore else
      if (error.response !== undefined) {
        // istanbul ignore else
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
